import { client } from '../client';
import { License } from './types/UserProfile';

export const deleteProviderLicense = async (provider_license_id: number, user_id: number): Promise<License> => {
  const { data } = await client.delete<License>(`/users/${user_id}/provider_profile/licenses/${provider_license_id}`);

  return data;
};
